import { IAskSchema } from './ask.model';
import { IStartEndTimeWindowSchema, WeekDay } from './availability.model';

export interface IMeetingTypeField<T> {
    value?: T;
}

export interface IMeetingTypeLearnedField<T> extends IMeetingTypeField<T> {
    managed?: boolean;
}

/**
 * Name and PSL
 */

/**
 * Availability
 * found under ./availability.model
 */

export interface IStartOffsetsSchema {
    m00: boolean;
    m15: boolean;
    m30: boolean;
    m45: boolean;
}

export interface IStartOffsetStartTime {
    kind: 'offsets';
    offsets: IStartOffsetsSchema;
}

export interface IIncrementStartTime {
    kind: 'increment';
    increment: number;
}
export interface IBufferTimes {
    beforeMinutes: number;
    afterMinutes: number;
}

export interface IMaxEventsPerPeriod {
    days: {
        [weekDay in WeekDay]?: number;
    };
}

/**
 * Location and conferencing
 */

/**
 * Additional customization options (ie Invitee Experience)
 */
export interface IMeetingTypeAsk {
    questions?: IAskSchema[];
}

type confirmationUXOption = 'default' | 'redirect';
export interface IMeetingTypeConfirmationUX {
    option: confirmationUXOption;
    redirectSeconds?: number;
    redirectURL?: string;
}

export interface ITrackingId {
    type: 'google';
    id: string;
}

/**
 * Misc
 */

export type CalendarDisplay = 'daily' | 'monthly';

/** Languages - zoom-ai-api/src/core/services/translate.ts */
export interface ILanguage {
    iso: string;
    isoFlag?: string;
    desc: string;
    descLocale?: string;
    meetingAcceptance?: boolean;
    chat?: boolean;
}

export const Languages: ILanguage[] = [
    { iso: 'en', desc: 'English', meetingAcceptance: true, chat: true },
    { iso: 'fr', desc: 'French', meetingAcceptance: true, chat: true, descLocale: 'Français' },
    { iso: 'es', desc: 'Spanish', meetingAcceptance: true, chat: true, descLocale: 'Español' },
    { iso: 'it', desc: 'Italian', meetingAcceptance: false, chat: true, descLocale: 'Italiano' },
    { iso: 'ja', desc: 'Japanese', meetingAcceptance: false, chat: true, isoFlag: 'jp', descLocale: '日本語' },
    { iso: 'pt', desc: 'Portuguese', meetingAcceptance: true, chat: true, descLocale: 'Português' },
    { iso: 'de', desc: 'German', meetingAcceptance: true, chat: false, descLocale: 'Deutsch' },
    { iso: 'sv', desc: 'Swedish', meetingAcceptance: true, chat: false, isoFlag: 'se', descLocale: 'Svenska' }
];

export type SupportedLanguagesType = typeof Languages[number]['iso'];
